import { Box, Button, Card, Modal } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import VuiButton from "components/VuiButton";
import SystemUpdateAltOutlinedIcon from "@mui/icons-material/SystemUpdateAltOutlined";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import VuiTypography from "components/VuiTypography";
import VuiBox from "components/VuiBox";

export function KitModal({
  showModalHiddenImages,
  modalLabel,
  modalCurrentImageIndex,
  setModalCurrentImageIndex,
  setShowModalHiddenImages,
  images,
  actionModal,
  downloadText,
  pages,
  setPages,
}) {

  const ResourceImage = ({ item, i }) => (
    <VuiBox
      onClick={() => {
        setModalCurrentImageIndex(i);
        setShowModalHiddenImages(true);
      }}
      component="img"
      src={item?.url}
      sx={({ breakpoints }) => ({
        width: "100%",
        maxWidth: "20rem",
        maxHeight: "30rem",
        objectFit: "container",
        borderRadius: "15px",
        [breakpoints.down(550)]: {
          maxWidth: "10rem",
        },
      })}
    />
  );

  const ResourceCard = ({ item, i }) => (
    <VuiBox
      onClick={() => {
        setModalCurrentImageIndex(i);
        // setShowModalHiddenImages(true);
      }}
      component="div"
      sx={({ breakpoints }) => ({
        width: "100%",
        maxWidth: "20rem",
        maxHeight: "30rem",
        objectFit: "container",
        borderRadius: "15px",
        [breakpoints.down(550)]: {
          maxWidth: "10rem",
        },
        backgroundColor: "#0e1534",
        color: "white", 
        padding: "15px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "200px",
        gap: "10px",
      })}
    >
      <Box
        sx={{
          maxHeight: "25rem",
          overflowY: "auto",
          scrollbarWidth: "thin",
          scrollbarColor: "#39444c #0e1534",
        }}
      >
        <VuiTypography
          color="white"
          sx={{
            fontWeight: "700",
            fontSize: "16px",
          }}
        >
          {item.filename}
        </VuiTypography>
      </Box>

      <Box>
        <VuiTypography
          color="white"
          sx={{
            fontSize: "14px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {item.url}
        </VuiTypography>
      </Box>
    </VuiBox>
  );

  const getComponentByType = (type, data) => {
    switch (type) {
      case 1:
        return ResourceImage(data);
      case 2:
        return ResourceCard(data);
      default:
        return ResourceImage(data);
    }
  }

  const ImageButtons = ({ item, i }) => (
    <VuiButton
      onClick={() => actionModal(images[modalCurrentImageIndex])}
      hover="none"
      sx={({ breakpoints }) => ({
        background: "transparent",
        fontSize: "12px",
        height: "35px",
        fontWeight: "700",
        borderSize: "2px",
        borderColor: "white",
        padding: "0px 8px",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        background: "white",
        "&.hover": {
          backgroundColor: "white",
        },
      })}
    >
      {downloadText}
      <SystemUpdateAltOutlinedIcon
        sx={{
          margin: "0 5px",
        }}
      />
    </VuiButton>
  );

  const CardButtons = ({ item, i }) => (
    <Box sx={{ display: "flex", gap: "15px" }}>
    <VuiButton
      onClick={() => handleOpen(images[modalCurrentImageIndex].url)}
      hover="none"
      sx={({ breakpoints }) => ({
        background: "transparent",
        fontSize: "12px",
        height: "35px",
        fontWeight: "700",
        borderSize: "2px",
        borderColor: "white",
        padding: "0px 8px",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        background: "white",
        "&.hover": {
          backgroundColor: "white",
        },
      })}
    >
      Ir al recurso
      <OpenInNewIcon
        sx={{
          margin: "0 5px",
        }}
      />
    </VuiButton>
    <VuiButton
      onClick={() => handleCopy(images[modalCurrentImageIndex].url)}
      hover="none"
      sx={({ breakpoints }) => ({
        background: "transparent",
        fontSize: "12px",
        height: "35px",
        fontWeight: "700",
        borderSize: "2px",
        borderColor: "white",
        padding: "0px 8px",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        background: "white",
        "&.hover": {
          backgroundColor: "white",
        },
      })}
    >
      Copiar enlace
      <ContentCopyIcon
        sx={{
          margin: "0 5px",
        }}
      />
    </VuiButton>
    </Box>
  );

  const getComponentButtonsByType = (type, data) => {
    switch (type) {
      case 1:
        return ImageButtons(data);
      case 2:
        return CardButtons(data);
      default:
        return ImageButtons(data);
    }
  }

  const handleCopy = (url) => {
    navigator.clipboard.writeText(url);
  }

  const handleOpen = (url) => {
    window.open(url, "_blank");
  }
  
  return (
    <Modal
      open={showModalHiddenImages}
      onClose={() => setShowModalHiddenImages(false)}
      sx={{
        zIndex: 3000,
        padding: "1rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card
        sx={{
          margin: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          width: "100%",
          maxWidth: "775px",
          border: "none",
          "&:focus-visible": { borderColor: "red" },
        }}
      >
        <VuiTypography
          color="white"
          sx={{
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          {modalLabel}
        </VuiTypography>
        <VuiBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          <ArrowBackIosIcon
            onClick={() =>
              setModalCurrentImageIndex(
                modalCurrentImageIndex === 0 ? 0 : modalCurrentImageIndex - 1
              )
            }
            color="white"
            sx={{
              margin: "0 5px",
              cursor: "pointer",
            }}
          />
          {getComponentByType(images[modalCurrentImageIndex]?.type, {
            i: 0,
            item: images[modalCurrentImageIndex],
          })}
          <ArrowForwardIosIcon
            onClick={() =>
              setModalCurrentImageIndex(
                modalCurrentImageIndex + 1 === images.length
                  ? images.length - 1
                  : modalCurrentImageIndex + 1
              )
            }
            color="white"
            sx={{
              margin: "0 5px",
              cursor: "pointer",
            }}
          />
        </VuiBox>
        <VuiBox
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {getComponentButtonsByType(images[modalCurrentImageIndex]?.type, {
            i: 0,
            item: images[modalCurrentImageIndex],
          })}
        </VuiBox>
        <VuiBox
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
            maxWidth: "200px",
            margin: "0 auto",
            overflowX: "hidden",
          }}
        >
          {pages[0] > 1 && (
            <ArrowBackIosIcon
              color="white"
              sx={{
                cursor: "pointer",
              }}
              onClick={() => {
                const firstPage = pages[0];
                const newPages = Array(5)
                  .fill(0)
                  .map((_, i) => firstPage - i - 1)
                  .sort((a, b) => a - b)
                  .filter((page) => page >= 1);
                setPages(newPages);
              }}
            />
          )}
          {pages.map((page) => (
            <VuiBox key={page} onClick={() => setModalCurrentImageIndex(page - 1)}>
              <VuiTypography
                color="white"
                sx={{
                  fontWeight: modalCurrentImageIndex === page - 1 ? 700 : 100,
                  cursor: "pointer",
                }}
              >
                {page}
              </VuiTypography>
            </VuiBox>
          ))}
          {images.length > pages[pages.length - 1] && (
            <ArrowForwardIosIcon
              color="white"
              sx={{
                cursor: "pointer",
              }}
              onClick={() => {
                const { length } = images;
                const lastPage = pages[pages.length - 1];
                const newPages = Array(5)
                  .fill(0)
                  .map((_, i) => lastPage + i + 1)
                  .filter((page) => page <= length);
                setPages(newPages);
              }}
            />
          )}
        </VuiBox>
      </Card>
    </Modal>
  );
}
